<div class="select-bank-section">

  <div class="bank-icon-section">
    <div class="heading">Please select your Bank to help us identify the best payment modes for you</div>
    <div class="top-banks">
      <button type="button" *ngFor="let bank of topBank" class="bank-icons" (click)="selectTopBank(bank?.code)" mat-stroked-button>
        <div class="logo" [class]="bank?.code"></div>
        <div class="name">{{bank?.name}}</div>
      </button>
    </div>
  </div>

  <div id="bank-dropdown" class="bank-dropdown">
    <form [formGroup]="netBankForm">
      <mat-form-field>
        <mat-select [formControl]="bankCode" placeholder="Select Bank" (openedChange)="resetSearch();submitTopBank()">
          <app-input class="search-input" inputType="text" [control]="searchText" [group]="searchForm" placeHolder="Search"
                      (OnChange)="search($event)">
          </app-input>
          <mat-option *ngFor="let bank of sort(config?.paymentOptions?.options?.RECURRINGBANK)" [value]="bank?.code" class="bankDropdownList">
            {{bank?.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>

    <div *ngIf="selectedBank?.name && unsupportedMethod && selectedBank?.code!=='NB_OTHER'" class="unsupport-text">{{selectedBank?.name}} does not support Auto Pay via {{unsupportedMethod}}</div>
  </div>

</div>